<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()"
  closable="false"
  [style]="{ width: '400px' }">
  <jni-task-calendar-view
    [refreshTasks]="refreshTasks"></jni-task-calendar-view>

  <div class="mt-3">
    <jni-to-do-list></jni-to-do-list>
  </div>

  <div class="mt-3">
    <jni-collaborators></jni-collaborators>
  </div>

  <div class="mt-3">
    <jni-reminders></jni-reminders>
  </div>

  <div class="mt-3">
    <jni-linked-task
      (openWorkflowSummary)="workflowSummary($event)"></jni-linked-task>
  </div>

  <div class="mt-3">
    <jni-activity-log></jni-activity-log>
  </div>

  <div class="sidebar-iconposition">
    <a (click)="closeSideBar()" class="sidebar-close-icon">
      <i class="pi pi-angle-right"></i>
    </a>
  </div>
</p-drawer>

<jni-modal-stacker
  *ngIf="displayProdWorkflowSummary"
  [displayModal]="displayProdWorkflowSummary"
  (closeEvent)="closeWorkflowModal()">
  <div class="panelBody">
    <jni-production-workflow-summary
      *ngIf="workflowId !== 0 && displayProdWorkflowSummary"
      [salesOrderId]="salesOrderId"
      [workflowId]="workflowId">
    </jni-production-workflow-summary>
  </div>
</jni-modal-stacker>
